import React from "react";
import "./components.css";
import { Col, Container, Row } from "react-bootstrap";
import CommonButton from "./CommonButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Call } from "./svg";
import Image from "next/image";
import choose from "../../public/assets/images/choose.png";
import dotGrid from "../../public/assets/images/dot-grid.png";
import Link from "next/link";
import { event } from "@/lib/analytics";
const OurCompany = () => {
  return (
    <div className="our-company-main">
      <Container>
        <Row>
          <Col xl={6} lg={4} md={12} className="align-self-center">
            <div className="" style={{ position: "relative" }}>
              <Image
                src={dotGrid}
                width={150}
                height={"auto"}
                className="img-fluid move-img"
                alt="animation"
              />
              <Image
                src={choose}
                width={600}
                height={"auto"}
                className="img-fluid mx-auto d-block reveal fade-bottom"
                alt="About Our Company"
              />
            </div>
          </Col>
          <Col xl={6} lg={8} md={12}>
            <div className="com-pill">About Our Company ~</div>
            <h2 className="com-title reveal fade-bottom">
              Choose <span>The Best</span> IT Service Company
            </h2>
            <p className="reveal fade-bottom">
              We believe that each element of a web page or app interface can
              create a memorable experience, transforming your business into
              something exceptional. Our mission is to provide you with
              distinctive business assets that reflect the unique identity of
              your brand, enhancing your reputation through superior user
              experience. This ensures that users delight in engaging with your
              brand every time, in every interaction.
            </p>
            <div className="d-flex gap-3 reveal fade-bottom flex-wrap">
              <Link href="/contact#inquiry" aria-label={`View Contact us Page`}>
                <CommonButton
                  label="Free Consultation"
                  className="btn-primary free-consultation"
                  onClick={() =>
                    event({
                      action: "free consultation",
                      params: { page: "home page" },
                    })
                  }
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                      style={{ height: "20px", fill: "#fff" }}
                    >
                      <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                    </svg>
                  }
                />
              </Link>
              <div className="d-flex gap-2">
                <div className="d-block">
                  <div className="call-icon">
                    <Call className="rise-shake" />
                  </div>
                </div>
                <div className="call-text">
                  <span>Call to help</span>
                  <Link href="tel:8200872703" aria-label={`Call Now`}>
                    <div>+91 820-0872703</div>
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default OurCompany;
